import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService } from '@ddt-web/analytics';
import { FundStatsConfigKey, InjectConfig } from '@ddt-web/config-layer';
import { FundStatus } from '@ddt-web/fund-stats';

@Component({
	selector: 'ac-pdf-fund-filtering',
	templateUrl: './pdf-fund-filtering.component.html',
	styleUrls: ['./pdf-fund-filtering.component.scss']
})

export class PdfFundFilteringComponent implements OnInit {

	@InjectConfig(FundStatsConfigKey.STATUSES) public readonly statuses: FundStatus[] = [];

	@Output() public fundStatuesChanged: EventEmitter<Map<string, boolean>> = new EventEmitter<Map<string, boolean>>();

	public readonly statusDescriptions = {};
	public isToggleExpanded: boolean = false;

	public iqFundStatuses: Map<string, boolean>;

	constructor(private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public ngOnInit(): void {
		this.iqFundStatuses = new Map(
			this.statuses.map((status: FundStatus) => [status.statusId, true])
		);
		this.fundStatuesChanged.emit(this.iqFundStatuses);
	}

	public onToggleChange(): void {
		this.isToggleExpanded = !this.isToggleExpanded;
		this.tealiumAnalyticsService.trackEventTealium(
			new TealiumAnalyticsEvent('generate report:fund filtering toggle:' + (this.isToggleExpanded ? 'on' : 'off'), null)
		);
	}

	public onCheckBoxClick(key: string): void {
		this.iqFundStatuses.set(key, !this.iqFundStatuses.get(key));
		this.tealiumAnalyticsService.trackEventTealium(
			new TealiumAnalyticsEvent('generate report:fund filtering:' + key + ':' + (this.iqFundStatuses.get(key) ? 'checked' : 'unchecked'), null)
		);
		this.fundStatuesChanged.emit(this.iqFundStatuses);
	}

}
